import { createContext, useContext } from "react";

const ThemeContext = createContext();

const theme = {
  colors: {
    primary: "#000d6b",
    secondary: "#f9a826",
    white: "#ffffff",
    text: "#333333",
    lightGray: "#f5f5f5",
  },
  fonts: {
    primary: '"Tajawal", sans-serif',
  },
  shadows: {
    small: "0 2px 10px rgba(0, 0, 0, 0.1)",
    medium: "0 2px 15px rgba(0, 0, 0, 0.2)",
  },
};

export const ThemeProvider = ({ children }) => {
  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
